import React, { useState, useEffect } from 'react';

// Friendly names per supported language
const NAMES = {
  es: 'Español',
  en: 'English',
  fr: 'Français',
  it: 'Italiano',
  'pt-BR': 'Português',
};

const FLAG = {
  es: '🇪🇸', en: '🇬🇧', fr: '🇫🇷', it: '🇮🇹', 'pt-BR': '🇧🇷',
};

const MSG = {
  es: { detected: 'Detectamos que estás en', switchTo: '¿Cambiar el idioma a', yes: 'Sí, cambiar', no: 'No' },
  en: { detected: 'We detected you are in', switchTo: 'Switch language to',         yes: 'Yes, switch', no: 'No' },
  fr: { detected: 'Nous avons détecté que vous êtes en', switchTo: 'Changer la langue en', yes: 'Oui',     no: 'Non' },
  it: { detected: 'Abbiamo rilevato che sei in',         switchTo: 'Cambiare la lingua in', yes: 'Sì',      no: 'No' },
};

const styles = {
  wrap: {
    position: 'fixed', left: 0, right: 0, bottom: 0,
    zIndex: 10000,
    display: 'flex', justifyContent: 'center',
    padding: '12px 16px',
    pointerEvents: 'none',
    fontFamily: "'Inter','Segoe UI',system-ui,sans-serif",
  },
  card: {
    pointerEvents: 'auto',
    background: 'rgba(13, 17, 23, 0.95)',
    color: '#fff',
    border: '1px solid rgba(0,255,240,0.35)',
    borderRadius: 14,
    padding: '12px 18px',
    boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
    display: 'flex', alignItems: 'center', gap: 14,
    maxWidth: 640,
    backdropFilter: 'blur(8px)',
    fontSize: 14,
  },
  text: { lineHeight: 1.4, color: '#cfeff7' },
  strong: { color: '#00fff0', fontWeight: 700 },
  btn: {
    background: 'linear-gradient(135deg,#00fff0,#1e3a5f)', color: '#001620',
    border: 'none', borderRadius: 8, padding: '8px 14px',
    fontWeight: 700, cursor: 'pointer', fontSize: 13,
    transition: 'transform .15s ease',
  },
  btnSecondary: {
    background: 'transparent', color: '#9aa', border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 8, padding: '8px 12px', fontWeight: 500, cursor: 'pointer', fontSize: 13,
  },
};

const LanguageSuggestionBanner = ({ currentLang, suggested, onAccept, onDismiss }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show only if:
    // - we have a suggestion
    // - it differs from current
    // - user has not dismissed before
    // - user has not yet manually picked
    if (!suggested || !suggested.lang) { setVisible(false); return; }
    if (suggested.lang === currentLang) { setVisible(false); return; }
    if (localStorage.getItem('klorum.langBannerDismissed') === '1') { setVisible(false); return; }
    if (localStorage.getItem('klorum.langPicked') === '1') { setVisible(false); return; }
    setVisible(true);
  }, [suggested, currentLang]);

  if (!visible) return null;
  const target = suggested.lang;
  const flag = FLAG[target] || '🌐';
  const name = NAMES[target] || target;

  const accept = () => {
    onAccept && onAccept(target);
    setVisible(false);
  };
  const dismiss = () => {
    localStorage.setItem('klorum.langBannerDismissed', '1');
    onDismiss && onDismiss();
    setVisible(false);
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={{ fontSize: 26 }}>{flag}</div>
        <div style={styles.text}>
          {(MSG[currentLang] || MSG.es).detected}{' '}
          <span style={styles.strong}>{suggested.country || '—'}</span>.{' '}
          {(MSG[currentLang] || MSG.es).switchTo}{' '}
          <span style={styles.strong}>{name}</span>?
        </div>
        <button type="button" style={styles.btn} onClick={accept}>
          {(MSG[currentLang] || MSG.es).yes}
        </button>
        <button type="button" style={styles.btnSecondary} onClick={dismiss}>
          {(MSG[currentLang] || MSG.es).no}
        </button>
      </div>
    </div>
  );
};

export default LanguageSuggestionBanner;
